import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5408d9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "deliveries" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye-slash mr-2" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye mr-2" }, null, -1))
const _hoisted_5 = { class: "filters__content" }
const _hoisted_6 = { class: "mt-3 flex items-center justify-end" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_9 = { class: "bg-white rounded mt-8 p-3" }
const _hoisted_10 = { class: "mt-4" }
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col items-center justify-center select-none"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Загрузка списка секторов...", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-red-500" }, " При получении списка секторов произошла ошибка ", -1))
const _hoisted_14 = {
  key: 2,
  class: "text-sm text-gray-400"
}
const _hoisted_15 = {
  key: 1,
  class: "rounded border grid grid-cols-7 gap-3 p-3"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Сектор", -1))
const _hoisted_18 = { class: "bg-white rounded mt-8" }
const _hoisted_19 = { class: "p-3" }
const _hoisted_20 = { class: "flex items-center justify-end" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cog" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download mr-2" }, null, -1))
const _hoisted_23 = { class: "mt-3" }
const _hoisted_24 = {
  class: "max-w-full overflow-hidden overflow-x-auto",
  style: {"padding-bottom":"40px"}
}
const _hoisted_25 = {
  key: 0,
  class: "flex flex-col text-sm text-gray-400 select-none justify-center items-center"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Загрузка данных...", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, " При получении данных произошла ошибка ", -1))
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { class: "flex items-center justify-end pb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mass_approve_modal = _resolveComponent("mass-approve-modal")!
  const _component_wait_list_status_modal = _resolveComponent("wait-list-status-modal")!
  const _component_wait_list_mass_status_modal = _resolveComponent("wait-list-mass-status-modal")!
  const _component_container_invoice_panel_information = _resolveComponent("container-invoice-panel-information")!
  const _component_modal_panel = _resolveComponent("modal-panel")!
  const _component_courier_payment_modal = _resolveComponent("courier-payment-modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_map = _resolveComponent("new-map")!
  const _component_loader = _resolveComponent("loader")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_deliveries_table_row = _resolveComponent("deliveries-table-row")!
  const _component_new_table = _resolveComponent("new-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mass_state.is_opened)
      ? (_openBlock(), _createBlock(_component_mass_approve_modal, {
          key: 0,
          loading: _ctx.mass_state.is_loading,
          onCancel: _ctx.cancelMassApprove,
          onSubmit: _ctx.cancelMassApprove
        }, null, 8, ["loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.wait_list_state.is_opened)
      ? (_openBlock(), _createBlock(_component_wait_list_status_modal, {
          key: 1,
          order: _ctx.wait_list_state.order,
          loading: _ctx.wait_list_state.is_loading,
          type: 2,
          onCancel: _ctx.cancelWaitList,
          onSubmit: _ctx.setWaitListStatus
        }, null, 8, ["order", "loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.wait_list_mass_state.is_opened)
      ? (_openBlock(), _createBlock(_component_wait_list_mass_status_modal, {
          key: 2,
          "invoice-ids": _ctx.selectedInvoiceIds,
          loading: _ctx.wait_list_mass_state.is_loading,
          onCancel: _ctx.cancelWaitListMass,
          onSubmit: _ctx.cancelWaitListMass
        }, null, 8, ["invoice-ids", "loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.invoice_state.is_opened && _ctx.invoice_state.invoice)
      ? (_openBlock(), _createBlock(_component_modal_panel, {
          key: 3,
          title: _ctx.invoice_state.invoice ? _ctx.invoice_state.invoice.invoiceNumber : '',
          "title-to": _ctx.invoice_state.invoice ? `/invoice/${_ctx.invoice_state.invoice.invoiceId}` : '',
          "cheap-text": _ctx.invoice_state.invoice_status ? _ctx.invoice_state.invoice_status.name : '',
          "cheap-class": _ctx.getCheapClass,
          "without-footer": "",
          onCancel: _ctx.closeInvoicePanel
        }, {
          default: _withCtx(() => [
            _createVNode(_component_container_invoice_panel_information, {
              "invoice-id": _ctx.invoice_state.invoice.invoiceId,
              "has-parking-files": _ctx.invoice_state.invoice.hasParkingCourierPayment,
              "has-road-files": _ctx.invoice_state.invoice.hasRoadCourierPayment,
              row: _ctx.invoice_state.invoice,
              "is-delivery": "",
              onWaitList: _ctx.startWaitList,
              onCancel: _ctx.closeInvoicePanel,
              onPayment: _ctx.togglePayment,
              onInvoiceLoaded: _ctx.onInvoiceLoaded
            }, null, 8, ["invoice-id", "has-parking-files", "has-road-files", "row", "onWaitList", "onCancel", "onPayment", "onInvoiceLoaded"])
          ]),
          _: 1
        }, 8, ["title", "title-to", "cheap-text", "cheap-class", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.payment_state.is_opened && _ctx.payment_state.clientId)
      ? (_openBlock(), _createBlock(_component_courier_payment_modal, {
          key: 4,
          "client-id": _ctx.payment_state.clientId,
          loading: _ctx.payment_state.is_loading,
          type: _ctx.payment_state.type,
          onCancel: _ctx.togglePayment,
          onSubmit: _ctx.savePaymentDeliveries
        }, null, 8, ["client-id", "loading", "type", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Доставки" }),
      (_ctx.state.is_opened)
        ? (_openBlock(), _createBlock(_component_new_button, {
            key: 0,
            class: "NewButton--outline",
            onClick: _ctx.closeMap
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" Скрыть карту ")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : (_openBlock(), _createBlock(_component_new_button, {
            key: 1,
            class: "NewButton--outline",
            onClick: _ctx.openMap
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(" Показать карту ")
            ]),
            _: 1
          }, 8, ["onClick"]))
    ]),
    _createElementVNode("form", {
      class: "deliveries__filters",
      onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFiltersChanged && _ctx.onFiltersChanged(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_new_input, {
          placeholder: "Введите номер накладной",
          value: _ctx.filters_state.invoiceNumber,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters_state.invoiceNumber) = $event)),
          disabled: _ctx.deliveries_state.is_loading || _ctx.deliveries_map_state.is_loading
        }, null, 8, ["value", "disabled"]),
        _createVNode(_component_new_input, {
          placeholder: "Номер накладной заказчика",
          value: _ctx.filters_state.dopInvoiceNumber,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.dopInvoiceNumber) = $event)),
          disabled: _ctx.deliveries_state.is_loading || _ctx.deliveries_map_state.is_loading
        }, null, 8, ["value", "disabled"]),
        _createVNode(_component_new_input, {
          type: "date",
          placeholder: "Выберите дату c",
          value: _ctx.filters_state.deliveredAtFrom,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters_state.deliveredAtFrom) = $event)),
          disabled: _ctx.deliveries_state.is_loading || _ctx.deliveries_map_state.is_loading,
          "is-invalid": _ctx.filters$.deliveredAtFrom.$error
        }, null, 8, ["value", "disabled", "is-invalid"]),
        _createVNode(_component_new_input, {
          type: "date",
          placeholder: "Выберите дату по",
          value: _ctx.filters_state.deliveredAtTo,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters_state.deliveredAtTo) = $event)),
          disabled: _ctx.deliveries_state.is_loading || _ctx.deliveries_map_state.is_loading,
          "is-invalid": _ctx.filters$.deliveredAtTo.$error
        }, null, 8, ["value", "disabled", "is-invalid"]),
        _createVNode(_component_new_select, {
          "can-deselect": "",
          placeholder: "Выберите курьера",
          "search-without-refresh": "",
          label: "fullName",
          searchBy: "fullName",
          value: _ctx.filters_state.courierId,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters_state.courierId) = $event)),
          disabled: _ctx.deliveries_state.is_loading || _ctx.deliveries_map_state.is_loading,
          loading: _ctx.data_state.couriers.is_loading,
          failed: _ctx.data_state.couriers.is_failed,
          options: _ctx.data_state.couriers.list,
          onRefresh: _ctx.loadCouriers
        }, null, 8, ["value", "disabled", "loading", "failed", "options", "onRefresh"]),
        _createVNode(_component_new_select, {
          "can-deselect": "",
          placeholder: "Выберите сектор",
          "search-without-refresh": "",
          value: _ctx.filters_state.sectorId,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters_state.sectorId) = $event)),
          disabled: _ctx.deliveries_state.is_loading || _ctx.deliveries_map_state.is_loading,
          loading: _ctx.data_state.sectors.is_loading,
          failed: _ctx.data_state.sectors.is_failed,
          options: _ctx.data_state.sectors.list,
          onRefresh: _ctx.loadSectors
        }, {
          "selected-option": _withCtx(({ option }) => [
            _createTextVNode(_toDisplayString(option.name) + " (" + _toDisplayString(option.dispatcherSectorName) + ") ", 1)
          ]),
          option: _withCtx(({ option }) => [
            _createTextVNode(_toDisplayString(option.name) + " (" + _toDisplayString(option.dispatcherSectorName) + ") ", 1)
          ]),
          _: 1
        }, 8, ["value", "disabled", "loading", "failed", "options", "onRefresh"]),
        _createVNode(_component_new_select, {
          "can-deselect": "",
          placeholder: "Выберите статус доставки",
          label: "title",
          "search-without-refresh": "",
          "search-by": "title",
          options: _ctx.data_state.status_types.list,
          loading: _ctx.data_state.status_types.is_loading,
          failed: _ctx.data_state.status_types.is_failed,
          "error-text": "Произошла ошибка при получении списка типов статусов",
          multiselect: "",
          value: _ctx.filters_state.statusIds,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters_state.statusIds) = $event)),
          onRefresh: _ctx.loadStatusTypes
        }, null, 8, ["options", "loading", "failed", "value", "onRefresh"]),
        _createVNode(_component_new_select, {
          "can-deselect": "",
          placeholder: "Выберите статус ЛО",
          label: "name",
          "search-without-refresh": "",
          options: _ctx.data_state.statuses_lo.list,
          loading: _ctx.data_state.statuses_lo.is_loading,
          failed: _ctx.data_state.statuses_lo.is_failed,
          "error-text": "Произошла ошибка при получении списка статусов",
          multiselect: "",
          value: _ctx.filters_state.waitListStatusIds,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters_state.waitListStatusIds) = $event)),
          onRefresh: _ctx.loadStatusesLO
        }, null, 8, ["options", "loading", "failed", "value", "onRefresh"]),
        _createVNode(_component_new_input, {
          placeholder: "Введите адрес",
          label: "name",
          value: _ctx.filters_state.address,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters_state.address) = $event))
        }, null, 8, ["value"]),
        _createVNode(_component_new_select, {
          "can-deselect": "",
          placeholder: "Выберите клиента",
          "search-without-refresh": "",
          options: _ctx.data_state.companies.list,
          loading: _ctx.data_state.companies.is_loading,
          failed: _ctx.data_state.companies.is_failed,
          "error-text": "Произошла ошибка при получении списка компаний",
          value: _ctx.filters_state.companyId,
          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters_state.companyId) = $event)),
          onRefresh: _ctx.loadCompanies
        }, null, 8, ["options", "loading", "failed", "value", "onRefresh"]),
        _createVNode(_component_new_select, {
          "can-deselect": "",
          placeholder: "Название контейнера",
          "search-without-refresh": "",
          options: _ctx.data_state.containers.list,
          loading: _ctx.data_state.containers.is_loading,
          failed: _ctx.data_state.containers.is_failed,
          "error-text": "Произошла ошибка при получении списка контейнеров",
          value: _ctx.filters_state.containerId,
          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filters_state.containerId) = $event)),
          onRefresh: _ctx.loadContainers,
          label: "title",
          "search-by": "title"
        }, null, 8, ["options", "loading", "failed", "value", "onRefresh"]),
        _createVNode(_component_new_select, {
          "can-deselect": "",
          value: _ctx.filters_state.waitListComment,
          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filters_state.waitListComment) = $event)),
          placeholder: "Комментарий",
          options: _ctx.comments_state.list,
          loading: _ctx.comments_state.is_loading,
          failed: _ctx.comments_state.is_failed,
          "error-text": "При получении списка произошла ошибка",
          "select-by": "text",
          label: "text",
          "search-by": "text",
          onRefresh: _ctx.loadComments,
          onChange: _ctx.onCommentChange
        }, null, 8, ["value", "options", "loading", "failed", "onRefresh", "onChange"]),
        _createVNode(_component_new_select, {
          "can-deselect": "",
          value: _ctx.filters_state.isPickup,
          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filters_state.isPickup) = $event)),
          placeholder: "Самовывоз",
          "select-by": "key",
          options: _ctx.PICKUP_OPTIONS,
          searchable: false
        }, null, 8, ["value", "options"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_new_button, {
          type: "button",
          class: "NewButton--reset",
          disabled: _ctx.deliveries_state.is_loading || _ctx.deliveries_map_state.is_loading,
          onClick: _ctx.resetFilters
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _createTextVNode(" Сбросить ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_new_button, {
          type: "submit",
          class: "NewButton--search ml-4",
          disabled: _ctx.deliveries_state.is_loading || _ctx.deliveries_map_state.is_loading
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ], 32),
    _withDirectives(_createElementVNode("div", _hoisted_9, [
      _createVNode(_component_new_map, {
        class: "deliveries__map",
        id: "deliveries-map",
        controls: ['zoomControl'],
        onMapReady: _ctx.onMapReady
      }, null, 8, ["onMapReady"]),
      _createElementVNode("div", _hoisted_10, [
        (
                        _ctx.data_state.sectors.is_loading ||
                        _ctx.data_state.sectors.is_failed ||
                        _ctx.data_state.sectors.list.length === 0
                    )
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_ctx.data_state.sectors.is_loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_loader, { class: "primary" }),
                    _hoisted_12
                  ], 64))
                : (_ctx.data_state.sectors.is_failed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_13,
                      _createVNode(_component_new_button, {
                        class: "NewButton--outline mt-1",
                        onClick: _ctx.loadSectors
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Обновить ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
                  : (_ctx.data_state.sectors.list.length === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, "Список секторов пуст"))
                    : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data_state.sectors.list, (sector) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: sector.id,
                  class: "flex items-center cursor-pointer",
                  onClick: ($event: any) => (_ctx.setMapCenterOnSector(sector))
                }, [
                  _hoisted_17,
                  _createElementVNode("span", {
                    class: "text-sm font-bold ml-2",
                    style: _normalizeStyle({ color: sector.color })
                  }, _toDisplayString(sector.name), 5)
                ], 8, _hoisted_16))
              }), 128))
            ]))
      ])
    ], 512), [
      [_vShow, _ctx.state.is_opened]
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_new_button, {
            class: "NewButton--search mr-3",
            loading: _ctx.deliveries_state.is_loading || _ctx.deliveries_map_state.is_loading,
            disabled: !_ctx.deliveries_state.orders.length,
            onClick: _ctx.tablesStore.toggleModal
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          }, 8, ["loading", "disabled", "onClick"]),
          (
                            _ctx.havePermissions(['cabinet.store-wait-list-status']) &&
                            _ctx.deliveries_state.selected_orders.length
                        )
            ? (_openBlock(), _createBlock(_component_new_button, {
                key: 0,
                loading: _ctx.wait_list_mass_state.is_loading,
                disabled: _ctx.wait_list_mass_state.is_loading,
                class: "NewButton--search mr-3",
                onClick: _ctx.startWaitListMass
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Добавить в ЛО ")
                ]),
                _: 1
              }, 8, ["loading", "disabled", "onClick"]))
            : _createCommentVNode("", true),
          (_ctx.havePermissions(['dispatcher.delivery-mass-approve']))
            ? (_openBlock(), _createBlock(_component_new_button, {
                key: 1,
                loading: _ctx.mass_state.is_loading,
                disabled: _ctx.mass_state.is_loading,
                class: "NewButton--search mr-3",
                onClick: _ctx.startMassApprove
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Проставить ДК ")
                ]),
                _: 1
              }, 8, ["loading", "disabled", "onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_new_button, {
            loading: _ctx.report_state.is_loading,
            disabled: _ctx.report_state.is_loading,
            class: "NewButton--search mr-3",
            onClick: _ctx.downloadReport
          }, {
            default: _withCtx(() => [
              _hoisted_22,
              _createTextVNode(" Выгрузить отчет ")
            ]),
            _: 1
          }, 8, ["loading", "disabled", "onClick"]),
          _createVNode(_component_new_limit, {
            disabled: _ctx.deliveries_state.is_loading || _ctx.deliveries_map_state.is_loading,
            value: _ctx.deliveries_state.filters.limit,
            "total-items": _ctx.deliveries_state.filters.total_items,
            onChange: _ctx.onLimitChange
          }, null, 8, ["disabled", "value", "total-items", "onChange"]),
          _createVNode(_component_new_pagination, {
            class: "ml-6",
            disabled: _ctx.deliveries_state.is_loading || _ctx.deliveries_map_state.is_loading,
            "current-page": _ctx.deliveries_state.filters.current_page,
            "total-pages": _ctx.deliveries_state.filters.total_pages,
            onChangePage: _ctx.onChangePage
          }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_table_scroll_wrapper, {
              loading: _ctx.deliveries_state.is_loading
            }, {
              default: _withCtx(() => [
                (
                                    _ctx.deliveries_state.is_loading ||
                                    _ctx.deliveries_map_state.is_loading ||
                                    _ctx.deliveries_state.is_failed ||
                                    _ctx.deliveries_state.orders.length === 0
                                )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (
                                        _ctx.deliveries_state.is_loading ||
                                        _ctx.deliveries_map_state.is_loading
                                    )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_loader, { class: "primary" }),
                            _hoisted_26
                          ], 64))
                        : (_ctx.deliveries_state.is_failed)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_27,
                              _createVNode(_component_new_button, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Обновить ")
                                ]),
                                _: 1
                              })
                            ], 64))
                          : _createCommentVNode("", true),
                      (_ctx.deliveries_state.orders.length === 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_28, "Список доставок пуст"))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock(_component_new_table, {
                      key: 1,
                      columns: _ctx.COLUMNS,
                      rows: _ctx.deliveries_state.orders,
                      "clickable-rows": "",
                      "has-checkbox-column": "",
                      "selected-rows": _ctx.deliveries_state.selected_orders,
                      onSelectAll: _ctx.onSelectAll,
                      onUnselectAll: _ctx.onUnselectAll,
                      onSelectRow: _ctx.onSelectRow,
                      onUnselectRow: _ctx.onUnselectRow,
                      onRowClick: _ctx.openInvoicePanel
                    }, {
                      td: _withCtx(({ column, row, index }) => [
                        _createVNode(_component_deliveries_table_row, {
                          column: column,
                          row: row,
                          index: index,
                          onPayment: _ctx.togglePayment,
                          onWaitList: _ctx.startWaitList
                        }, null, 8, ["column", "row", "index", "onPayment", "onWaitList"])
                      ]),
                      _: 1
                    }, 8, ["columns", "rows", "selected-rows", "onSelectAll", "onUnselectAll", "onSelectRow", "onUnselectRow", "onRowClick"]))
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_new_limit, {
            disabled: _ctx.deliveries_state.is_loading || _ctx.deliveries_map_state.is_loading,
            value: _ctx.deliveries_state.filters.limit,
            "total-items": _ctx.deliveries_state.filters.total_items,
            onChange: _ctx.onLimitChange
          }, null, 8, ["disabled", "value", "total-items", "onChange"]),
          _createVNode(_component_new_pagination, {
            class: "ml-6",
            disabled: _ctx.deliveries_state.is_loading || _ctx.deliveries_map_state.is_loading,
            "current-page": _ctx.deliveries_state.filters.current_page,
            "total-pages": _ctx.deliveries_state.filters.total_pages,
            onChangePage: _ctx.onChangePage
          }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
        ])
      ])
    ])
  ]))
}